import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { T } from "./content";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { Marquee } from "./components/site/Marquee";
import { Status } from "./components/site/Status";
import { About } from "./components/site/About";
import { Practice } from "./components/site/Practice";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");
  const lenis = useRef(null);
  const t = T[lang];

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const l = new Lenis({ duration: 1.15 });
    lenis.current = l;
    let id;
    const raf = (time) => { l.raf(time); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); l.destroy(); };
  }, []);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) lenis.current ? lenis.current.scrollTo(el, { offset: -70 }) : el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App" data-testid="app-root">
      <Header t={t} lang={lang} setLang={setLang} go={go} />
      <main>
        <Hero t={t} go={go} lang={lang} />
        <Status items={t.status} />
        <Marquee items={t.marquee} />
        <About t={t} />
        <Practice t={t} go={go} />
        <Contact t={t} />
      </main>
      <Footer t={t} go={go} />
    </div>
  );
}

export default App;
